import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "h1" }
const _hoisted_2 = { class: "profile-form-container" }
const _hoisted_3 = { class: "form-section" }
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = { class: "form-row" }
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-row" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "date-input-group" }
const _hoisted_16 = { class: "date-display" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-section" }
const _hoisted_19 = { class: "form-row" }
const _hoisted_20 = { class: "form-row" }
const _hoisted_21 = { class: "form-row" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "form-row" }
const _hoisted_24 = { class: "form-row" }
const _hoisted_25 = { class: "form-row" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "form-row" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-row" }
const _hoisted_30 = { class: "form-section" }
const _hoisted_31 = { class: "form-row" }
const _hoisted_32 = { class: "date-input-group" }
const _hoisted_33 = { class: "date-display" }
const _hoisted_34 = { class: "form-row" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "form-row" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "form-row" }
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "form-row" }
const _hoisted_41 = { class: "form-section" }
const _hoisted_42 = { class: "form-row" }
const _hoisted_43 = { class: "form-row" }
const _hoisted_44 = { class: "date-input-group" }
const _hoisted_45 = { class: "date-display" }
const _hoisted_46 = { class: "form-row" }
const _hoisted_47 = { class: "date-input-group" }
const _hoisted_48 = { class: "date-display" }
const _hoisted_49 = { class: "form-section" }
const _hoisted_50 = { class: "form-row" }
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "form-row" }
const _hoisted_53 = { class: "form-row" }
const _hoisted_54 = { class: "date-input-group" }
const _hoisted_55 = { class: "date-display" }
const _hoisted_56 = { class: "form-row" }
const _hoisted_57 = { class: "date-input-group" }
const _hoisted_58 = { class: "date-display" }
const _hoisted_59 = { class: "form-row" }
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "form-row checkbox-row" }
const _hoisted_62 = { class: "button-row" }
const _hoisted_63 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.isAddMode ? 'Add New Officer' : 'Update Profile'), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[39] || (_cache[39] = _createElementVNode("div", { class: "section-title" }, "Personal Information", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[33] || (_cache[33] = _createElementVNode("label", null, [
            _createTextVNode("First Name "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.FirstName) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.FirstName]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[34] || (_cache[34] = _createElementVNode("label", null, [
            _createTextVNode("Last Name "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formData.LastName) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.LastName]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[35] || (_cache[35] = _createElementVNode("label", null, "Previously Known As", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.PreviouslyKnownAs) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.PreviouslyKnownAs]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[36] || (_cache[36] = _createElementVNode("label", null, [
            _createTextVNode("Mobile "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.MobileNumber) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.MobileNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[37] || (_cache[37] = _createElementVNode("label", null, [
            _createTextVNode("Email "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formData.Email) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.Email]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[38] || (_cache[38] = _createElementVNode("label", null, "Phone2", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formData.Phone2) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.Phone2]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "section-title" }, "Work Information", -1)),
        _createElementVNode("div", _hoisted_11, [
          _cache[41] || (_cache[41] = _createElementVNode("label", null, [
            _createTextVNode("Company "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.formData.SecurityCompanyId) = $event))
          }, [
            _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "Select Company", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.companiesList, (company) => {
              return (_openBlock(), _createElementBlock("option", {
                key: company.companyId,
                value: company.companyId
              }, _toDisplayString(company.companyName), 9, _hoisted_12))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.formData.SecurityCompanyId]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[42] || (_cache[42] = _createElementVNode("label", null, [
            _createTextVNode("SIA No. "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.formData.SiabadageNumber) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.SiabadageNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[43] || (_cache[43] = _createElementVNode("label", null, [
            _createTextVNode("SIA Exp. Date "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.SiaExpiryDate)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formData.SiaExpiryDate) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.SiaExpiryDate]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[44] || (_cache[44] = _createElementVNode("label", null, [
            _createTextVNode("NI/UTR "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.formData.Ninumber) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.Ninumber]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "section-title" }, "Address Information", -1)),
        _createElementVNode("div", _hoisted_19, [
          _cache[46] || (_cache[46] = _createElementVNode("label", null, [
            _createTextVNode("House Name/Number "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.formData.HouseNameNumber) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.HouseNameNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[47] || (_cache[47] = _createElementVNode("label", null, "Street", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.formData.StreetAdress) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.StreetAdress]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[48] || (_cache[48] = _createElementVNode("label", null, [
            _createTextVNode("City "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.selectedCityName) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cityList, (city) => {
              return (_openBlock(), _createElementBlock("option", {
                key: city.cityId,
                value: city.name
              }, _toDisplayString(city.name), 9, _hoisted_22))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedCityName]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[49] || (_cache[49] = _createElementVNode("label", null, "County", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.formData.County) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.County]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[50] || (_cache[50] = _createElementVNode("label", null, [
            _createTextVNode("PostCode "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.formData.PostCode) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.PostCode]
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[51] || (_cache[51] = _createElementVNode("label", null, [
            _createTextVNode("Country "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.selectedAddressCountry) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
              return (_openBlock(), _createElementBlock("option", {
                key: n.id,
                value: n.name
              }, _toDisplayString(n.name), 9, _hoisted_26))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedAddressCountry]
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[52] || (_cache[52] = _createElementVNode("label", null, [
            _createTextVNode("Conveyance "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.selectedConveyanceName) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conveyanceListArray, (conveyance) => {
              return (_openBlock(), _createElementBlock("option", {
                key: conveyance.id,
                value: conveyance.name
              }, _toDisplayString(conveyance.name), 9, _hoisted_28))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedConveyanceName]
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[53] || (_cache[53] = _createElementVNode("label", null, [
            _createTextVNode("Emergency Contact "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.formData.NextOfKin) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.NextOfKin]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _cache[60] || (_cache[60] = _createElementVNode("div", { class: "section-title" }, "Origin Information", -1)),
        _createElementVNode("div", _hoisted_31, [
          _cache[55] || (_cache[55] = _createElementVNode("label", null, [
            _createTextVNode("Date Of Birth "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.DateOfBirth)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.formData.DateOfBirth) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.DateOfBirth]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _cache[56] || (_cache[56] = _createElementVNode("label", null, [
            _createTextVNode("Country Of Birth "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.selectedCountryOfBirth) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
              return (_openBlock(), _createElementBlock("option", {
                key: n.id,
                value: n.name
              }, _toDisplayString(n.name), 9, _hoisted_35))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedCountryOfBirth]
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _cache[57] || (_cache[57] = _createElementVNode("label", null, [
            _createTextVNode("Nationality "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.selectedNationality) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
              return (_openBlock(), _createElementBlock("option", {
                key: n.id,
                value: n.name
              }, _toDisplayString(n.name), 9, _hoisted_37))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedNationality]
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _cache[58] || (_cache[58] = _createElementVNode("label", null, [
            _createTextVNode("Gender "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.selectedGenderType) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.genderList, (g) => {
              return (_openBlock(), _createElementBlock("option", {
                key: g.id,
                value: g.name
              }, _toDisplayString(g.name), 9, _hoisted_39))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedGenderType]
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _cache[59] || (_cache[59] = _createElementVNode("label", null, [
            _createTextVNode("Place Of Birth "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.formData.PlaceOfBirth) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.PlaceOfBirth]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _cache[64] || (_cache[64] = _createElementVNode("div", { class: "section-title" }, "Passport Information", -1)),
        _createElementVNode("div", _hoisted_42, [
          _cache[61] || (_cache[61] = _createElementVNode("label", null, "Passport No", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.formData.PassportNo) = $event))
          }, null, 512), [
            [_vModelText, $setup.formData.PassportNo]
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _cache[62] || (_cache[62] = _createElementVNode("label", null, "Expires On", -1)),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("span", _hoisted_45, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.PassportExpiryDate)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.formData.PassportExpiryDate) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PassportExpiryDate]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _cache[63] || (_cache[63] = _createElementVNode("label", null, "Visa Expires", -1)),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("span", _hoisted_48, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.VisaExpiryDate)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.formData.VisaExpiryDate) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.VisaExpiryDate]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        _cache[71] || (_cache[71] = _createElementVNode("div", { class: "section-title" }, "Identity Document Information", -1)),
        _createElementVNode("div", _hoisted_50, [
          _cache[65] || (_cache[65] = _createElementVNode("label", null, [
            _createTextVNode("ID Document "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.selectedIdDocumentName) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentTypesList, (dt) => {
              return (_openBlock(), _createElementBlock("option", {
                key: dt.id,
                value: dt.name
              }, _toDisplayString(dt.name), 9, _hoisted_51))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedIdDocumentName]
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _cache[66] || (_cache[66] = _createElementVNode("label", null, [
            _createTextVNode("Number "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "input",
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.idDocumentNumber) = $event))
          }, null, 512), [
            [_vModelText, $setup.idDocumentNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _cache[67] || (_cache[67] = _createElementVNode("label", null, [
            _createTextVNode("Issue Date "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", _hoisted_55, "(" + _toDisplayString($setup.formatDateForDisplay($setup.idDocumentIssueDate)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.idDocumentIssueDate) = $event))
            }, null, 512), [
              [_vModelText, $setup.idDocumentIssueDate]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _cache[68] || (_cache[68] = _createElementVNode("label", null, [
            _createTextVNode("Expiry Date "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("span", _hoisted_58, "(" + _toDisplayString($setup.formatDateForDisplay($setup.idDocumentExpiryDate)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.idDocumentExpiryDate) = $event))
            }, null, 512), [
              [_vModelText, $setup.idDocumentExpiryDate]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _cache[69] || (_cache[69] = _createElementVNode("label", null, [
            _createTextVNode("Issued By "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.selectedIdDocumentCountryOfIssue) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
              return (_openBlock(), _createElementBlock("option", {
                key: n.id,
                value: n.name
              }, _toDisplayString(n.name), 9, _hoisted_60))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedIdDocumentCountryOfIssue]
          ])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.isPrivacyPolicyAgreed) = $event))
          }, null, 512), [
            [_vModelCheckbox, $setup.isPrivacyPolicyAgreed]
          ]),
          _cache[70] || (_cache[70] = _createElementVNode("label", null, [
            _createTextVNode("By Submitting this form you agree to our "),
            _createElementVNode("a", {
              href: "https://eaglesecurityltd.co.uk/privacy-policy-2",
              target: "blank"
            }, "Privacy Policy")
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => ($setup.UpdateOfficer && $setup.UpdateOfficer(...args))),
          disabled: $setup.isSaving
        }, _toDisplayString($setup.isSaving ? 'Saving...' : ($props.isAddMode ? 'Add Officer' : 'Save')), 9, _hoisted_63)
      ])
    ])
  ], 64))
}